import { OnInit, Component } from '@angular/core';
import {first} from "rxjs";
import {ConcessionService} from "../../core/services/concession.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-tarifs-departements',
  templateUrl: './tarifs-departements.component.html',
  styleUrls: ['./tarifs-departements.component.scss']
})
export class TarifsDepartementsComponent implements OnInit {
  selectedDep: any = null;
  concession: any = null;
  honoraires: any[] = []
  listDepsSearched: any[] = [];
  constructor(
    private activatedRoute: ActivatedRoute,
    private concessionService: ConcessionService,
  ) {
    this.activatedRoute.params.subscribe((params) => {
      this.concession = params['concession'];
      this.selectedDep = params['dep'];
    });
  }
  ngOnInit() {
    this.getListeDeps();
  }
  getListeDeps() {
    this.concessionService
      .getListeDeps(['property_details'])
      .pipe(first())
      .subscribe((response:any) => {
        this.listDepsSearched = response.data.departements;
        for(let dep in this.listDepsSearched ){
          this.honoraires[this.listDepsSearched[dep].num] = this.listDepsSearched[dep];
        }
      });
  }

}
